// ** Redux Imports
import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { successAlert, errorAlert } from '@alert'

export const getAllData = createAsyncThunk('projects/getAllData', async () => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/project')
  return response.data.result
})

export const getBrands = createAsyncThunk('projects/getBrands', async () => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/brand')
  return response.data.data
})
export const getProducts = createAsyncThunk('projects/getProducts', async () => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/product?with_pagination=no')
  return response.data.data
})
export const getCategories = createAsyncThunk('projects/getCategories', async () => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/category')
  return response.data.data
})
export const resetUser = createAsyncThunk('projects/resetUser', () => {
  return null
})

export const getData = createAsyncThunk('projects/getData', async params => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/project?', { params })
  return {
    params,
    data: response.data.data.data,
    totalPages: response.data?.data.total,
    loading: true
  }
})

export const getUser = createAsyncThunk('projects/getUser', async id => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + `/api/dashboard/project/${id}`)
  return response.data.data[0]
})

export const addUser = createAsyncThunk('projects/addUser', async (user, { dispatch, getState }) => {
  await axios
    .post(process.env.REACT_APP_BASE_URL + '/api/dashboard/project', user, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
      successAlert()
    })
    .catch(err => {
      errorAlert(err?.response?.data?.message)
    })
  await dispatch(getData(getState().projects.params))
  // await dispatch(getAllData())
  return user
})
export const addComb = createAsyncThunk('projects/addComb', async (params, { dispatch, getState }) => {
  await axios
    .post(process.env.REACT_APP_BASE_URL + '/api/dashboard/variation', params.user, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
      successAlert()
    })
    .catch(err => {
      if (err?.response?.data?.message) {
        errorAlert(err?.response?.data?.message)
      } else {
        errorAlert(err)
      }
    })
  await dispatch(getUser(params.project_id))
  return user
})

export const updateUser = createAsyncThunk('projects/updateUser', async (params, { dispatch, getState }) => {
  await axios
    .post(process.env.REACT_APP_BASE_URL + `/api/dashboard/project/${params.project_id}`, params.user, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
      successAlert()
    })
    .catch(err => {
      errorAlert(err?.response?.data?.message)
    })
  await dispatch(getData(getState().projects.params))
  await dispatch(getUser(params.project_id))
  return user
})

export const updateComb = createAsyncThunk('projects/updateComb', async (params, { dispatch, getState }) => {
  await axios
    .post(process.env.REACT_APP_BASE_URL + `/api/dashboard/variation/${params.id}`, params.user, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
      successAlert()
    })
    .catch(err => {
      if (err?.response?.data?.message) {
        errorAlert(err?.response?.data?.message)
      } else {
        errorAlert(err)
      }
    })
  await dispatch(getUser(params.project_id))
  return user
})

export const deleteUser = createAsyncThunk('projects/deleteUser', async (id, { dispatch, getState }) => {
  await axios
    .delete(process.env.REACT_APP_BASE_URL + `/api/dashboard/project/${id}`)
    .then(res => {
      successAlert()
    })
    .catch(err => {
      if (err?.response?.data?.message) {
        errorAlert(err?.response?.data?.message)
      } else {
        errorAlert(err)
      }
    })
  await dispatch(getData(getState().projects.params))
  return id
})
export const deleteComb = createAsyncThunk('projects/deleteComb', async (params, { dispatch, getState }) => {
  await axios
    .delete(process.env.REACT_APP_BASE_URL + `/api/dashboard/variation/${params.id}`)
    .then(res => {
      successAlert()
    })
    .catch(err => {
      if (err?.response?.data?.message) {
        errorAlert(err?.response?.data?.message)
      } else {
        errorAlert(err)
      }
    })
  await dispatch(getUser(params.project_id))
  return id
})

export const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    brands: [],
    categories: [],
    products: [],
    selectedUser: null,
    selectedToEdit: null,
    createData: null,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = action.payload.loading
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.brands = action.payload
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.products = action.payload
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.categories = action.payload
      })
      .addCase(resetUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default projectsSlice.reducer
